import { render } from "./recoeds-emergency-alarm.vue?vue&type=template&id=95f3c0b0&scoped=true&ts=true"
import script from "./recoeds-emergency-alarm.vue?vue&type=script&lang=ts"
export * from "./recoeds-emergency-alarm.vue?vue&type=script&lang=ts"

import "./recoeds-emergency-alarm.vue?vue&type=style&index=0&id=95f3c0b0&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f3c0b0"]])

export default __exports__